/**
 * ? @description : Bar Chart for Students Performances
 */

// Dependencies
import React, { useState, useEffect } from "react";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  Title,
} from "chart.js";
import { Pie } from "react-chartjs-2";
import Axios from "../../../../../axios/Axios";
import axios from "axios";


// Register Chart Properties
ChartJS.register(
  ArcElement,
  Tooltip,
  Legend,
  Title
);

function SessionPerformance(props) {
  // console.log(props);
  const [pieData, setPieData] = useState([]);
  const { 0: id, 2: level_id } = props;
  const studentId = props.studentId
  const levelId = props.levelId;

  // console.log(pieData);
  useEffect(() => {
    const controller = axios.CancelToken.source();

    if (id && level_id && level_id !== "-") {
      (async () => {

        let data = {
          stud_id: id,
          level_id: level_id
        }

        try {
          const response = await Axios("post", "student/get/studentfeedback", true, data, { cancelToken: controller.token });
          if (response.status === 200) {
            setPieData(response.data)
          }
        } catch (error) {
          if (!axios.isCancel(error)) {
            console.log(error);
          }
        }
      })()
    }
    return () => {
      controller.cancel();
  } }, [id, level_id])

  useEffect(() => {
    const controller = axios.CancelToken.source();
    if (studentId && levelId && levelId !== "-") {
      (async () => {

        let data = {
          stud_id: studentId,
          level_id: levelId
        }

        try {
          const response = await Axios("post", "student/get/studentfeedback", true, data,{ cancelToken: controller.token });
          if (response.status === 200) {
            setPieData(response.data)
          }
        } catch (error) {
          if (!axios.isCancel(error)) {
            console.log(error);
          }
        }
      })()
    }
    return () => {
      controller.cancel();
  }
  }, [studentId, levelId])


  let data = {
    labels: pieData.map(data => data.session_feedback),
    datasets: [
      {
        label: "Students Performances",
        data: pieData.map(data => data.feedback_count),
        backgroundColor: ["#E98EAD", "#3A4F7A", "#FFC6D3"],
        borderWidth: 1,
        borderColor: "white"
      },
    ],
  };

  let options = {
    maintainAspectRatio: true,
    legend: {
      labels: {
        fontSize: 15,
      },
    },
  };

  return (
    <Pie data={data} options={options} />
  );
}

export default SessionPerformance;